import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  ButtonGroup,
  Button,
} from '@folio/stripes/components';

import { FILTER_ROUTES } from '../../../../../constants';

const FilterNavigationButton = ({ path }) => (
  <ButtonGroup fullWidth>
    {
      Object.keys(FILTER_ROUTES).map(name => (
        <Button
          key={name}
          buttonStyle={`${path === FILTER_ROUTES[name] ? 'primary' : 'default'}`}
          id={name}
          to={`${FILTER_ROUTES[name]}`}
        >
          <FormattedMessage id={`ui-task-list.filters.${name}`} />
        </Button>
      ))
    }
  </ButtonGroup>
);

FilterNavigationButton.propTypes = {
  path: PropTypes.string.isRequired
};

export default FilterNavigationButton;
